import React, { useState } from 'react'
import { supabase } from '../supabaseClient'

function TestRedactionPage() {
  const [selectedFile, setSelectedFile] = useState(null)
  const [originalUrl, setOriginalUrl] = useState('')
  const [redactedUrl, setRedactedUrl] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0])
  }

  const handleUploadAndRedact = async () => {
    setLoading(true)
    setError('')
    setOriginalUrl('')
    setRedactedUrl('')

    try {
      if (!selectedFile) throw new Error('No file selected.')

      const fileName = `${Date.now()}_${selectedFile.name}`
      const path = `original/${fileName}`

      // Upload to Supabase
      const { error: uploadError } = await supabase.storage
        .from('documents')
        .upload(path, selectedFile)

      if (uploadError) throw uploadError

      const supabaseUrl = 'https://lklkcjkatinjgcfvgsah.supabase.co' // 🔁 replace with your actual Supabase project URL

      const publicPath = `${supabaseUrl}/storage/v1/object/public/documents/original/${fileName}`
      setOriginalUrl(publicPath)


      // Call API to redact
      const res = await fetch('/api/redact-image', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ imagePath: path, fileName })
      })

      const data = await res.json()
      if (!res.ok) throw new Error(data.error || 'Redaction failed.')

      setRedactedUrl(`${supabaseUrl}/storage/v1/object/public/documents/redacted/${fileName}`)

    } catch (err) {
      console.error(err)
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div style={{ padding: 32 }}>
      <h1>🧪 PHI Redaction Test Page</h1>

      <input type="file" onChange={handleFileChange} accept="image/*" />
      <button onClick={handleUploadAndRedact} disabled={loading || !selectedFile}>
        {loading ? 'Processing...' : 'Upload & Redact'}
      </button>

      {error && <p style={{ color: 'red' }}>Error: {error}</p>}

      {originalUrl && (
        <div>
          <h3>📄 Original</h3>
          <img src={originalUrl} alt="Original" style={{ maxWidth: '400px' }} />
        </div>
      )}

      {redactedUrl && (
        <div>
          <h3>🕵️‍♂️ Redacted</h3>
          <img src={redactedUrl} alt="Redacted" style={{ maxWidth: '400px' }} />
        </div>
      )}
    </div>
  )
}

export default TestRedactionPage
